module.exports = __webpack_public_path__ + "img/vr_1.fb83066a.png";